import { lazy } from 'solid-js'
import { ROUTES } from '../router-utils.js'
import { messages } from '../../pages/complete-profile-page/complete-profile-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/complete-profile-page/complete-profile-page.jsx')),
    path: ROUTES.COMPLETE_PROFILE,
    showFooter: false,
    showHeader: false,
    titleMessage: messages.titleMessage,
}
